"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var Controller_1 = __importDefault(require("../Controller"));

var User =
/** @class */
function (_super) {
  __extends(User, _super);

  function User() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  User.prototype.register = function (user) {
    return __awaiter(this, void 0, void 0, function () {
      var registerRes, token, registeErr_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.isLoggedIn('company')) {
              console.error('No company currently logged in.');
              return [2
              /*return*/
              ];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , axios_1.default.put(this.getUrl() + "/user/register", user, {
              headers: {
                Authorization: "Bearer " + this.getToken("company")
              }
            })];

          case 2:
            registerRes = _a.sent();

            if (registerRes.data.success === true) {
              token = registerRes.data.data.token;
              this.saveToken(token, "user");
            }

            return [2
            /*return*/
            , registerRes.data];

          case 3:
            registeErr_1 = _a.sent();
            console.error(registeErr_1);
            return [2
            /*return*/
            , false];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  User.prototype.update = function (user) {
    return __awaiter(this, void 0, void 0, function () {
      var updateRes, token;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.isLoggedIn('user')) {
              console.error('No user currently logged in.');
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , axios_1.default.put(this.getUrl() + "/user/update", user, {
              headers: {
                Authorization: "Bearer " + this.getToken("user")
              }
            })];

          case 1:
            updateRes = _a.sent();

            if (updateRes.data.success === true) {
              token = updateRes.data.data.token;
              this.saveToken(token, "user");
            }

            return [2
            /*return*/
            , updateRes.data];
        }
      });
    });
  };

  User.prototype.changePassword = function (pwd) {
    return __awaiter(this, void 0, void 0, function () {
      var pwdChangeRes, pwdChangeErr_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.isLoggedIn('user')) {
              console.error('No user currently logged in.');
              return [2
              /*return*/
              ];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , axios_1.default.put(this.getUrl() + "/user/change-password", pwd, {
              headers: {
                'Authorization': "Bearer " + this.getToken('user')
              }
            })];

          case 2:
            pwdChangeRes = _a.sent();
            return [2
            /*return*/
            , pwdChangeRes.data];

          case 3:
            pwdChangeErr_1 = _a.sent();
            console.error(pwdChangeErr_1);
            return [2
            /*return*/
            , false];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  User.prototype.profile = function () {
    return __awaiter(this, void 0, void 0, function () {
      var profileRes, updateErr_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.isLoggedIn('user')) {
              console.error('No user currently logged in.');
              return [2
              /*return*/
              ];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , axios_1.default.get(this.getUrl() + "/user/profile", {
              headers: {
                'Authorization': "Bearer " + this.getToken("user")
              }
            })];

          case 2:
            profileRes = _a.sent();
            return [2
            /*return*/
            , profileRes.data];

          case 3:
            updateErr_1 = _a.sent();
            console.error(updateErr_1);
            return [2
            /*return*/
            , false];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  User.prototype.login = function (email, password, options) {
    return __awaiter(this, void 0, void 0, function () {
      var data, loginRes, token, loginErr_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.isLoggedIn("company")) {
              console.error("No company currently logged in.");
              return [2
              /*return*/
              , false];
            }

            if (this.isLoggedIn("user")) {
              console.log('Already logged in.');
              return [2
              /*return*/
              , {
                success: true,
                user: this.getTokenPayload("user")
              }];
            }

            data = {
              email: email,
              password: password
            }; // used for admin login, to disable syncing with company data

            if (options && options.disableOperations) data.disableOperations = true;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , axios_1.default.post(this.getUrl() + "/user/login", data, {
              headers: {
                'Authorization': "Bearer " + this.getToken('company')
              }
            })];

          case 2:
            loginRes = _a.sent();

            if (loginRes.data.success === true) {
              token = loginRes.data.data.token;
              this.saveToken(token, "user");
            }

            return [2
            /*return*/
            , loginRes.data];

          case 3:
            loginErr_1 = _a.sent();
            console.error(loginErr_1);
            return [2
            /*return*/
            , false];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  User.prototype.login_facebook = function (access_token) {
    return __awaiter(this, void 0, void 0, function () {
      var loginRes, token, loginErr_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.isLoggedIn("company")) {
              console.error("No company currently logged in.");
              return [2
              /*return*/
              , false];
            }

            if (this.isLoggedIn("user")) {
              console.log('Already logged in.');
              return [2
              /*return*/
              , {
                success: true,
                user: this.getTokenPayload("user")
              }];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , axios_1.default.post(this.getUrl() + "/user/facebook-login", {
              access_token: access_token
            }, {
              headers: {
                'Authorization': "Bearer " + this.getToken('company')
              }
            })];

          case 2:
            loginRes = _a.sent();

            if (loginRes.data.success === true) {
              token = loginRes.data.data.token;
              this.saveToken(token, "user");
            }

            return [2
            /*return*/
            , loginRes.data];

          case 3:
            loginErr_2 = _a.sent();
            console.error(loginErr_2);
            return [2
            /*return*/
            , false];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  User.prototype.addToStore = function (data, key) {
    return __awaiter(this, void 0, void 0, function () {
      var storeRes, storeErr_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.isLoggedIn('user')) {
              console.error('No user currently logged in.');
              return [2
              /*return*/
              ];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , axios_1.default.put(this.getUrl() + "/user/store/" + key, {
              data: data
            }, {
              headers: {
                'Authorization': "Bearer " + this.getToken("user")
              }
            })];

          case 2:
            storeRes = _a.sent();
            return [2
            /*return*/
            , storeRes.data];

          case 3:
            storeErr_1 = _a.sent();
            console.error(storeErr_1);
            return [2
            /*return*/
            , false];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  User.prototype.logout = function () {
    this.deleteUserToken();
  };

  User.prototype.queryStore = function (key, conditions) {
    return __awaiter(this, void 0, void 0, function () {
      var queryRes;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , axios_1.default.post(this.getUrl() + "/user/store/" + key, {
              conditions: conditions
            }, {
              headers: {
                'Authorization': "Bearer " + this.getToken("user")
              }
            })];

          case 1:
            queryRes = _a.sent();
            return [2
            /*return*/
            , queryRes.data];
        }
      });
    });
  };

  return User;
}(Controller_1.default);

exports.User = User;